import React from "react";
import AutoResizeTextarea from "../AutoResizeTextarea";

const PanelEtat = ({
  indicators,
  isDirty,
  setIsDirty,
  editableResult,
  setEditableResult,
}) => {
  // ── Extraction des données ──
  const client = indicators?.client || {};
  const cr = indicators?.compte_de_resultat || {};

  const exerciceN = client.exercice_N || "N";
  const exerciceN1 = client.exercice_N1 || "N-1";

  const caN = cr.ca_N || 0;
  const caN1 = cr.ca_N1 || 0;
  const caVarPct = cr.ca_var_pct || 0;
  const chargesFiscalesN = cr.charges_fiscales_N || 0;
  const chargesFiscalesN1 = cr.charges_fiscales_N1 || 0;
  const chargesGestionN = cr.charges_gestion_N || 0;
  const ebeN = cr.ebe_N || 0;
  const ebeN1 = cr.ebe_N1 || 0;
  const ebeVarPct = cr.ebe_var_pct || 0;
  const rexN = cr.rex_N || 0;
  const rexN1 = cr.rex_N1 || 0;
  const rexVarPct = cr.rex_var_pct || 0;
  const impotN = cr.impot_N || 0;
  const impotN1 = cr.impot_N1 || 0;
  const resultatNetN = cr.resultat_net_N || 0;
  const resultatNetN1 = cr.resultat_net_N1 || 0;
  const resultatNetVarPct = cr.resultat_net_var_pct || 0;

  const fmt = (v, d = 0) =>
    Number(v).toLocaleString("fr-FR", {
      minimumFractionDigits: d,
      maximumFractionDigits: d,
    });
  const fmtE = (v) => fmt(v) + " €";
  const fmtPct = (v) => (v >= 0 ? "+" : "") + fmt(v, 1) + "%";
  const deltaClass = (v) => (v >= 0 ? "pos" : "neg");

  const fiscaleVar = chargesFiscalesN1 - chargesFiscalesN;

  return (
    <div className="etat-wrapper">
      <style>{`
        .etat-wrapper {
          --brand:#7E1738; --brand-mid:#9B1F44;
          --bg:#F5F3F7;
          --border:#E6E3EC; --border-light:#F0EDF4;
          --text:#1A1525; --text-2:#4A4460; --muted:#8A849A;
          --blue:#2563EB; --blue-bg:#EFF6FF; --blue-mid:#DBEAFE;
          --green:#16A34A; --green-bg:#F0FDF4; --green-mid:#DCFCE7;
          --red:#DC2626; --red-bg:#FEF2F2; --red-mid:#FEE2E2;
          --indigo:#4F46E5; --indigo-bg:#EEF2FF; --indigo-mid:#C7D2FE;
          --radius:10px;
          font-family:'DM Sans',system-ui,sans-serif;
          color:var(--text);
          font-size:13px;
          padding:20px 28px 32px;
          background:var(--bg);
          display:flex;
          flex-direction:column;
          gap:16px;
        }

        .et-g2{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:14px;
          align-items:start;
        }
        .et-col{
          display:flex;
          flex-direction:column;
          gap:14px;
        }

        /* Cards */
        .et-card{
          background:#fff;
          border:1px solid var(--border);
          border-radius:var(--radius);
          padding:18px 20px;
        }
        .et-card-sm{
          padding:14px 16px;
        }
        .et-sec-label{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--muted);
          padding:4px 0 10px;
          border-bottom:1px solid var(--border);
          margin-bottom:14px;
        }

        /* Table */
        .et-tbl{
          width:100%;
          border-collapse:collapse;
          font-size:12.5px;
        }
        .et-tbl thead th{
          background:var(--bg);
          color:var(--text-2);
          padding:9px 12px;
          text-align:left;
          font-size:11px;
          font-weight:600;
          letter-spacing:.04em;
          border-bottom:1px solid var(--border);
          white-space:nowrap;
        }
        .et-tbl thead th:not(:first-child){text-align:right}
        .et-tbl td{
          padding:9px 12px;
          color:var(--text-2);
          border-bottom:1px solid var(--border-light);
          vertical-align:middle;
        }
        .et-tbl td:not(:first-child){
          text-align:right;
          font-variant-numeric:tabular-nums;
        }
        .et-tbl tbody tr:last-child td{border-bottom:none}
        .et-tbl tbody tr:hover{background:var(--bg)}
        .et-tbl .tr-tot td{
          background:var(--brand)!important;
          color:rgba(255,255,255,.95)!important;
          font-weight:600;
        }
        .v-pos{color:var(--green)!important;font-weight:600}
        .v-neg{color:var(--red)!important;font-weight:600}
        .et-tbl .tr-tot .v-pos,
        .et-tbl .tr-tot .v-neg{
          color:rgba(255,255,255,.95)!important;
        }

        /* KPI */
        .et-kpi-grid-2{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:14px;
        }
        .et-kpi-card{
          background:var(--kpi-bg,var(--blue-bg));
          border:1px solid var(--kpi-mid,var(--blue-mid));
          border-radius:var(--radius);
          padding:14px 16px;
          display:flex;
          flex-direction:column;
          gap:3px;
          transition:transform .15s,box-shadow .15s;
        }
        .et-kpi-card:hover{
          transform:translateY(-1px);
          box-shadow:0 4px 16px rgba(0,0,0,.07);
        }
        .et-kpi-number{
          font-size:20px;
          font-weight:700;
          color:var(--kpi-color,var(--blue));
          line-height:1.1;
          letter-spacing:-.02em;
        }
        .et-kpi-lbl{
          font-size:11px;
          font-weight:500;
          color:var(--kpi-color,var(--blue));
          opacity:.75;
          margin-top:1px;
        }
        .et-kpi-delta{
          display:inline-flex;
          align-items:center;
          font-size:10px;
          font-weight:500;
          padding:2px 8px;
          border-radius:20px;
          margin-top:5px;
          width:fit-content;
        }
        .et-kpi-delta.neg{background:rgba(220,38,38,.1);color:#B91C1C}
        .et-kpi-delta.pos{background:rgba(22,163,74,.1);color:#15803D}
        .et-kpi-delta.neu{background:rgba(100,100,120,.08);color:var(--text-2)}
        .kpi-blue{--kpi-bg:var(--blue-bg);--kpi-mid:var(--blue-mid);--kpi-color:var(--blue)}
        .kpi-green{--kpi-bg:var(--green-bg);--kpi-mid:var(--green-mid);--kpi-color:var(--green)}
        .kpi-red{--kpi-bg:var(--red-bg);--kpi-mid:var(--red-mid);--kpi-color:var(--red)}

        /* Bilan rows */
        .et-bilan-row{
          display:flex;
          justify-content:space-between;
          align-items:baseline;
          padding:7px 0;
          font-size:12.5px;
          border-bottom:1px solid var(--border-light);
        }
        .et-bilan-label{color:var(--muted)}
        .et-bilan-val{
          font-weight:600;
          color:var(--text);
          font-variant-numeric:tabular-nums;
        }
        .et-bilan-total{
          padding-top:10px;
          margin-top:4px;
          border-top:2px solid var(--text);
          border-bottom:none;
        }
        .et-bilan-total .et-bilan-label{
          font-weight:700;
          color:var(--text);
        }
        .et-bilan-total .et-bilan-val{
          font-size:16px;
          font-weight:700;
          color:var(--brand);
        }

        /* Info box */
        .et-info-box{
          background:#fff;
          border:1px solid var(--border);
          border-left:3px solid var(--blue);
          border-radius:var(--radius);
          padding:14px 16px;
        }
        .et-info-box-title{
          font-size:11px;
          font-weight:600;
          color:var(--blue);
          margin-bottom:6px;
        }
        .et-info-box-body{
          font-size:12px;
          color:var(--text-2);
          line-height:1.7;
        }

        /* Tiles */
        .et-tile-analyse{
          background:var(--indigo-bg);
          border:1px solid var(--indigo-mid);
          border-left:3px solid var(--indigo);
          border-radius:var(--radius);
          padding:16px 18px;
        }
        .et-tile-analyse-head{
          display:flex;
          align-items:center;
          gap:8px;
          margin-bottom:10px;
        }
        .et-tile-analyse-lbl{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--indigo);
        }
        .et-tile-analyse p{
          font-size:12.5px;
          line-height:1.8;
          color:#3730A3;
        }
        .et-tile-infos{
          background:#FDF0F3;
          border:1px solid #F2D0DA;
          border-left:3px solid var(--brand);
          border-radius:var(--radius);
          padding:16px 18px;
        }
        .et-tile-infos-head{
          font-size:10px;
          font-weight:700;
          letter-spacing:.14em;
          text-transform:uppercase;
          color:var(--brand);
          margin-bottom:10px;
        }
        .et-tile-infos p{
          font-size:12.5px;
          line-height:1.8;
          color:var(--text-2);
        }
      `}</style>

      {/* ── LIGNE 1 : IS + Charges fiscales ── */}
      <div className="et-g2">
        {/* Colonne gauche */}
        <div className="et-col">
          <div className="et-card">
            <div className="et-sec-label">Impôt sur les Sociétés (IS)</div>
            <table className="et-tbl">
              <thead>
                <tr>
                  <th>Poste</th>
                  <th>{exerciceN}</th>
                  <th>{exerciceN1}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>IS constaté</td>
                  <td className={impotN < 0 ? "v-pos" : "v-neg"}>
                    {fmtE(Math.abs(impotN))}
                  </td>
                  <td style={{ color: "var(--muted)" }}>
                    {fmtE(Math.abs(impotN1))}
                  </td>
                </tr>
                <tr>
                  <td>Résultat d'exploitation</td>
                  <td className={rexN >= 0 ? "v-pos" : "v-neg"}>
                    {fmtE(rexN)}
                  </td>
                  <td style={{ color: "var(--muted)" }}>{fmtE(rexN1)}</td>
                </tr>
                <tr className="tr-tot">
                  <td>Résultat net</td>
                  <td>{fmtE(resultatNetN)}</td>
                  <td>{fmtE(resultatNetN1)}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="et-kpi-grid-2">
            <div className="et-kpi-card kpi-blue">
              <div className="et-kpi-number">{fmtE(Math.abs(impotN))}</div>
              <div className="et-kpi-lbl">IS {exerciceN}</div>
              {impotN < 0 ? (
                <span className="et-kpi-delta pos">Crédit d'impôt</span>
              ) : (
                <span className="et-kpi-delta neg">Charge IS</span>
              )}
            </div>
            <div className="et-kpi-card kpi-green">
              <div className="et-kpi-number">{fmtE(chargesFiscalesN)}</div>
              <div className="et-kpi-lbl">Charges fiscales {exerciceN}</div>
              <span className={`et-kpi-delta ${deltaClass(fiscaleVar)}`}>
                vs {fmtE(chargesFiscalesN1)}
              </span>
            </div>
          </div>
        </div>

        {/* Colonne droite */}
        <div className="et-col">
          <div className="et-card">
            <div className="et-sec-label">Charges fiscales &amp; taxes</div>
            <div className="et-bilan-row">
              <span className="et-bilan-label">
                Charges fiscales {exerciceN}
              </span>
              <span className="et-bilan-val">{fmtE(chargesFiscalesN)}</span>
            </div>
            <div className="et-bilan-row">
              <span className="et-bilan-label">
                Charges fiscales {exerciceN1}
              </span>
              <span className="et-bilan-val" style={{ color: "var(--muted)" }}>
                {fmtE(chargesFiscalesN1)}
              </span>
            </div>
            <div className="et-bilan-row">
              <span className="et-bilan-label">
                Charges de gestion {exerciceN}
              </span>
              <span className="et-bilan-val">{fmtE(chargesGestionN)}</span>
            </div>
            <div className="et-bilan-row et-bilan-total">
              <span className="et-bilan-label">Total fiscal + gestion</span>
              <span className="et-bilan-val">
                {fmtE(chargesFiscalesN + chargesGestionN)}
              </span>
            </div>
          </div>

          {impotN < 0 && (
            <div className="et-info-box">
              <div className="et-info-box-title">
                ℹ️ Crédit d'impôt constaté
              </div>
              <div className="et-info-box-body">
                Crédit IS de {fmtE(Math.abs(impotN))} constaté en {exerciceN},
                résultant du déficit fiscal.
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ── LIGNE 2 : Analyse + Reco ── */}
      <div className="et-g2">
        <div
          className="rounded-md border-l-[3px] p-4"
          style={{ backgroundColor: "#EEF2FF", borderLeftColor: "#4F46E5" }}
        >
          <div className="flex items-center justify-between mb-2">
            <p className="text-xs font-semibold text-indigo-700 uppercase tracking-wide">
              Analyse
            </p>

            {isDirty.analyseEtat && (
              <span className="bg-amber-100 text-amber-700 border border-amber-200 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                Modifié
              </span>
            )}
          </div>

          <AutoResizeTextarea
            value={editableResult?.etat?.analyse || ""}
            onChange={(e) => {
              setIsDirty((prev) => ({
                ...prev,
                analyseEtat: true,
              }));
              setEditableResult((prev) => ({
                ...prev,
                etat: {
                  ...prev.etat,
                  analyse: e.target.value,
                },
              }));
            }}
            className="text-indigo-900/80"
          />
        </div>

        <div
          className="rounded-md border-l-[3px] p-4"
          style={{ backgroundColor: "#FDF0F3", borderLeftColor: "#7E1738" }}
        >
          <div className="flex items-center justify-between mb-2">
            <p
              className="text-xs font-semibold uppercase tracking-wide"
              style={{ color: "#7E1738" }}
            >
              Informations & Recommandations
            </p>
            {isDirty.informations_recommandationsEtat && (
              <span className="bg-amber-100 text-amber-700 border border-amber-200 text-[10px] px-2 py-0.5 rounded-md shadow-sm">
                Modifié
              </span>
            )}
          </div>

          <AutoResizeTextarea
            value={editableResult?.etat?.informations_recommandations || ""}
            onChange={(e) => {
              setIsDirty((prev) => ({
                ...prev,
                informations_recommandationsEtat: true,
              }));
              setEditableResult((prev) => ({
                ...prev,
                etat: {
                  ...prev.etat,
                  informations_recommandations: e.target.value,
                },
              }));
            }}
            className="text-foreground/80"
          />
        </div>
      </div>

      {/* ── LIGNE 3 : Récapitulatif financier ── */}
      <div className="et-card">
        <div className="et-sec-label">
          Récapitulatif financier {exerciceN} vs {exerciceN1}
        </div>
        <table className="et-tbl">
          <thead>
            <tr>
              <th>Indicateur</th>
              <th>{exerciceN}</th>
              <th>{exerciceN1}</th>
              <th>Variation</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Chiffre d'affaires</td>
              <td style={{ fontWeight: 600 }}>{fmtE(caN)}</td>
              <td style={{ color: "var(--muted)" }}>{fmtE(caN1)}</td>
              <td className={deltaClass(caVarPct)}>{fmtPct(caVarPct)}</td>
            </tr>
            <tr>
              <td>EBE</td>
              <td style={{ fontWeight: 600 }}>{fmtE(ebeN)}</td>
              <td style={{ color: "var(--muted)" }}>{fmtE(ebeN1)}</td>
              <td className={deltaClass(ebeVarPct)}>{fmtPct(ebeVarPct)}</td>
            </tr>
            <tr>
              <td>Résultat d'exploitation</td>
              <td style={{ fontWeight: 600 }}>{fmtE(rexN)}</td>
              <td style={{ color: "var(--muted)" }}>{fmtE(rexN1)}</td>
              <td className={deltaClass(rexVarPct)}>{fmtPct(rexVarPct)}</td>
            </tr>
            <tr>
              <td>IS</td>
              <td style={{ fontWeight: 600 }}>{fmtE(impotN)}</td>
              <td style={{ color: "var(--muted)" }}>{fmtE(impotN1)}</td>
              <td style={{ color: "var(--muted)" }}>—</td>
            </tr>
            <tr className="tr-tot">
              <td>Résultat net</td>
              <td>{fmtE(resultatNetN)}</td>
              <td>{fmtE(resultatNetN1)}</td>
              <td>{fmtPct(resultatNetVarPct)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PanelEtat;
